import React, { useState, useEffect } from 'react';

// ✅ IMPORTACIONES DE PÁGINAS (Rutas Absolutas)
import LandingPage from 'pages/LandingPage';
import ProfileSelection from 'pages/ProfileSelection';
import PantallaPasillo from 'pages/recepcion/PantallaPasillo'; 
import AdminModule from 'pages/admin/AdminModule';
import MaestroModule from 'pages/maestro/MaestroModule';
import PadreModule from 'pages/padre/PadreModule';
import RecepcionModule from 'pages/recepcion/RecepcionModule';

// ✅ IMPORTACIONES DE CONTEXTOS (Rutas Absolutas)
import { AuthProvider, useAuth } from 'context/AuthContext'; 
import { GlobalProvider } from 'context/GlobalContext';

function AppContent() {
  const { user, role, logout, loading } = useAuth();
  const [mostrandoLogin, setMostrandoLogin] = useState(false);
  const [esRutaTV, setEsRutaTV] = useState(window.location.pathname === '/tv');

  useEffect(() => {
    const manejarCambioRuta = () => setEsRutaTV(window.location.pathname === '/tv');
    window.addEventListener('popstate', manejarCambioRuta);
    return () => window.removeEventListener('popstate', manejarCambioRuta);
  }, []);

  // 1. MODO TV / PASILLO
  if (esRutaTV) return (
    <PantallaPasillo 
      alCerrar={() => { 
        window.history.pushState({}, '', '/'); 
        setEsRutaTV(false); 
      }} 
    />
  );
  
  // 2. CARGA INICIAL (SPINNER)
  if (loading) return (
    <div className="min-h-screen bg-[#0A2440] flex items-center justify-center">
      <div className="w-12 h-12 border-4 border-amber-500 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );

  // 3. FLUJO DE ACCESO (LANDING O SELECCIÓN DE PERFIL)
  if (!user) return (
    <div className="min-h-screen bg-slate-50">
      {!mostrandoLogin ? (
        <LandingPage alIniciar={() => setMostrandoLogin(true)} />
      ) : (
        <ProfileSelection alVolver={() => setMostrandoLogin(false)} />
      )}
    </div>
  );

  // 4. ROUTER POR ROLES (VISTA PRIVADA)
  return (
    <div className="min-h-screen bg-slate-50">
      {role === 'admin' && <AdminModule alSalir={logout} />}
      {role === 'maestro' && <MaestroModule alSalir={logout} />}
      {role === 'padre' && <PadreModule alSalir={logout} />}
      {role === 'recepcion' && <RecepcionModule alSalir={logout} />}
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <GlobalProvider>
        <AppContent />
      </GlobalProvider>
    </AuthProvider>
  );
}